import { render, staticRenderFns } from "./performanceAssignmentLineComponent.vue?vue&type=template&id=88d7f662&scoped=true&"
import script from "./performanceAssignmentLineComponent.vue?vue&type=script&lang=js&"
export * from "./performanceAssignmentLineComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d7f662",
  null
  
)

export default component.exports